import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Typography, Paper, FormControlLabel, Checkbox } from '@mui/material';
import Grid from '@mui/material/Grid';
import NavigationButtons from '../container/NavigationButtons';
import Person from './custom/Person';
import Address from './custom/Address';
import Flag from 'react-world-flags';

function PersonalInformation(props) {
  const dispatch = useDispatch()
  const activeStep = useSelector((state) => state.activeStep)
  const start = useSelector((state) => state.start)
  // const person = useSelector((state) => state.person)
  const initialPerson = useSelector((state) => state.person)
  const initialAddresses = useSelector((state) => state.addresses)

  // const [activeStep, setActiveStep] = useState(useSelector((state) => state.activeStep));
  // const [start, setStart] = useState(initialStart);
  const [person, setPerson] = useState(initialPerson);
  const [addresses, setAddresses] = useState(initialAddresses)

  const [countries, setCountries] = useState([]);
  const [inUnitedStates, setInUnitedStates] = useState(false);
  const [sameAddress, setSameAddress] = useState(false);

  const [requiredFields, setRequiredFields] = useState({person: false, address0: false, address1: false});

  // useEffect(() => {
  //   setActiveStep(activeStep)
  // }, [activeStep])
  useEffect(() => {
    // setStart(start)
    setRequiredFields({person: false, address0: false, address1: false})
  }, [start])
  useEffect(() => {
    setPerson(initialPerson)
  }, [initialPerson])
  // useEffect(() => {
  //   setAddresses(props.addresses)
  // }, [props.addresses])

  const updatePerson = (person) => {
    setPerson(person)
  }

  const handleChangeChecked = propertyName => event => {
    const newAddresses = {...addresses}

    setSameAddress(event.target.checked)
    if (event.target.checked) {
      const addressP = addresses[0]
      let newAddress
      var allReqDone = false;

      newAddress = {
        ...addressP,
        type: '1',
        country:{
          value: 'USA',
          label: [<Flag code='USA' height="12" />, ' ',  'UNITED STATES'],      
          countryDescription: 'UNITED STATES'
        } 
      };
      if (addressP.country !== undefined && addressP.country !== null && addressP.country.value !== null && 
            addressP.country.value !== undefined && addressP.country.value === 'USA') {
          newAddresses[1] = newAddress
      }
      setAddresses(newAddresses)
      // dispatch( updateAddress(newAddresses) )
      setSameAddress(sameAddress? false : true)  
      // this.setState({ addresses: addresses, sameAddress: sameAddress? false : true });

      if (newAddresses[1].streetName !== '' && newAddresses[1].city !== '' && newAddresses[1].country !== '') {
        allReqDone = true;
      }
      handleError('address1', allReqDone);
    } else {
        const addressU = addresses[1]

        const newAddressU = {
          ...addressU,
          streetName: '',
          state: '',
          city: '',
          othercity: '',
          zip: ''
        }
        
        newAddresses[1] = newAddressU
        // addresses.splice(1, 1);
        setSameAddress(sameAddress? false : true)
        setAddresses(newAddresses)
        // dispatch( updateAddress(newAddresses) )
        // this.setState({ addresses: addresses, sameAddress: sameAddress? false : true });
    }
  }

  const updateAddresses = (address, index) =>  {
    const newAddresses = {...addresses}

    newAddresses[index] = {...address}
        
    if (index === '0' && sameAddress && 
        (newAddresses[0].country === undefined || (newAddresses[0].country !== null && newAddresses[0].country.value === "USA"))) {      
      newAddresses[1] = {...address, type: '1'}
    } 
    setSameAddress((index === '1'? false : sameAddress)) 
    // dispatch( updateAddress(newAddresses) )
    setAddresses(newAddresses)
    // this.setState({addresses: newAddresses, sameAddress: (index === '1'? false : sameAddress)});      
  }

  const handleError = (propertyName, allReqDone) => {
    let addr0 = requiredFields.address0

    let newRequiredFields = {
      ...requiredFields,
      [propertyName]: allReqDone,      
    };

    if ((sameAddress && propertyName === 'address0' && allReqDone === true) || (sameAddress && addr0) ||
          start.personalOrBusiness === 'B') {
      newRequiredFields = {...newRequiredFields, address1 : true}
    }

    // console.log("pers inf req " + JSON.stringify(newRequiredFields) + ' '+ propertyName + ' ' + allReqDone)  
    setRequiredFields(newRequiredFields)
  }  

  return (
    <div>       
          <Paper sx={{
            padding: 2,
            textAlign: 'left',
            justifyContent: 'center',
            color: 'text.primary',
            backgroundColor: '#ffffff',
            borderRadius: '12px'
          }}>
          {/* <Person person={person} updatePerson={person => {dispatch(updatePerson(person)); dispatch(updateCarrier(person))}} handleError={handleError} */}
          {/* <Person person={person} updatePerson={person => {updatePerson(person)}} handleError={handleError}  */}
          <Person person={person} updatePerson={updatePerson} handleError={handleError} 
                      business={start.personalOrBusiness === 'B'? true : false} />
                            
              <Grid>
                <Typography sx={{
                  mr: 2,
                  fontSize: '0.9375rem',
                  color: 'text.primary',
                  pt: 4,
                  mb: 0,
                  fontWeight: "660"
                }}>{start.personalOrBusiness === 'B'? 'Business ' : undefined}
                  Permanent Address in United States or Abroad</Typography>
              </Grid>

              <Address address={addresses[0]} index='0' updateAddress={updateAddresses}  handleError={handleError} />                

              {start.personalOrBusiness !== 'B' &&
              <Grid>
                <Typography sx={{
                  mr: 2,
                  fontSize: '0.9375rem',
                  color: 'text.primary',
                  pt: 4,
                  mb: 0,
                  fontWeight: "660"
                }}>Address while in the United States</Typography>
                {(addresses[0].country === undefined || addresses[0].country === null || 
                            (addresses[0].country !== null  && addresses[0].country.value === "USA")) &&   
                <FormControlLabel
                    sx={{ ml: 0 }}
                    control={
                    <Checkbox
                      checked={addresses[0].country !== null && sameAddress ? true: false}
                      onChange={handleChangeChecked('sameAddress')}
                      value={sameAddress}
                    />
                  }
                  label="Same Address as Permanent Address"
                /> }
              </Grid>
              }
              
              {start.personalOrBusiness !== 'B' &&
              <Address address={addresses[1]} index='1' updateAddress={updateAddresses} 
                                        sameAddress={sameAddress} inUnitedStates={true} handleError={handleError} />
              }

              <NavigationButtons person={person} addresses={addresses} inUnitedStates={true}
                        allReqDone={requiredFields.person && requiredFields.address0 && requiredFields.address1} />
        </Paper>
      </div>
  );
}

export default PersonalInformation;